import {Module} from "vuex";
import axios from "@/plugins/axios";
import errorHandler from '@/services/errorHandler';
import Vue from "vue";
import moment from "moment";

export interface IPrinter {
    id: number
    company_id: number
    name: string
    brand?: string
    model?: string
    group?: string
    description?: string
    integration?: string
    mqtt_live?: boolean
    connection?: Record<string, any>
    has_credentials?: boolean
    sync_enabled?: boolean
    operator_only?: boolean
    control_limited?: boolean
    ams_summary?: Record<string, unknown>
    needs_reconfigure?: boolean
    state?: string
    progress?: number
    eta_seconds?: number
    nozzle_temperature?: number
    nozzle_target?: number
    bed_temperature?: number
    bed_target?: number
    chamber_temperature?: number
    filename?: string
    layer?: string
    message?: string
    last_error?: string
    last_seen_at?: string
    rtsp?: string
    key?: string
    status?: string
    estimated_print_time?: number
    cpu_temp?: number
    thumbnail_path?: string
    extruder_temperature?: number
    extruder_target?: number
    extruder_power?: number
    heater_bed_temperature?: number
    heater_bed_power?: number
    heater_bed_target?: number
    heater_generic_temperature?: number
    print_stats_filament_used?: number
    print_stats_print_duration?: number
    print_stats_total_duration?: number
    print_stats_filename?: string
    print_stats_state?: string
    print_stats_message?: string
    toolhead_print_time?: number
    display_status_progress?: number
    idle_timeout_printing_time?: number
    idle_timeout_state?: string
    last_status_changed_at?: string
    webhooks_state?: string
    webhooks_state_message?: string
    updated_at?: string
}

const printerModule = <Module<any, any>>{
    namespaced: true,
    state: () => ({
        printers: <IPrinter[]>[]
    }),
    getters: {
        printers: state => state.printers
    },
    actions: {
        async getPrinters({state}) {
            try {
                const body: any = await axios.get(`printers`, { params: { take: -1 }})
                state.printers = body.printers;
            } catch (e) {
                errorHandler.handle(e, { showDialog: true });
                state.printers = [];
            }
        },
        updatePrinter({state}, {printer_id, values}) {
            const printerIdx = state.printers.findIndex((p: IPrinter) => p.id === printer_id);
            if (printerIdx >= 0) {
                Vue.set(state.printers, printerIdx, {
                    ...state.printers[printerIdx],
                    ...values,
                    updated_at: values.updated_at || values.last_seen_at || moment().format("YYYY-MM-DD HH:mm:ss"),
                });
            }
        }
    }
}

export default printerModule;
